(function () {
  var SECTION_SELECTOR = '.oddit-section-shop-by-shade';
  var PRODUCT_SLIDE_ACTIVE = 'oddit-section-shop-by-shade__product-slide--active';
  var PRODUCT_DETAILS_ACTIVE = 'oddit-section-shop-by-shade__product-details--active';
  var LIFESTYLE_SLIDE_ACTIVE = 'oddit-section-shop-by-shade__lifestyle-slide--active';
  var SWATCH_ACTIVE = 'oddit-section-shop-by-shade__swatch--active';
  var DRAGGING_CLASS = 'oddit-section-shop-by-shade__product-slides--dragging';
  var DEFAULT_AUTOPLAY_INTERVAL_MS = 5000;
  var DRAG_THRESHOLD_PX = 50;

  function initSection(section) {
    var productSlidesContainer = section.querySelector('.oddit-section-shop-by-shade__product-slides');
    var productSlides = section.querySelectorAll('.oddit-section-shop-by-shade__product-slide');
    var productDetails = section.querySelectorAll('.oddit-section-shop-by-shade__product-details');
    var lifestyleSlides = section.querySelectorAll('.oddit-section-shop-by-shade__lifestyle-slide');
    var swatches = section.querySelectorAll('.oddit-section-shop-by-shade__swatch');

    if (!productSlides.length || !swatches.length) return;

    var totalCount = swatches.length;
    var currentIndex = 0;
    var autoplayTimer = null;
    var prefersReducedMotion = window.matchMedia
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var autoplayEnabled = (section.dataset.autoplay || 'true').toLowerCase() !== 'false';
    var parsedSpeed = parseFloat(section.dataset.autoplaySpeed);
    var autoplayIntervalMs = (!isNaN(parsedSpeed) && parsedSpeed > 0)
      ? parsedSpeed * 1000
      : DEFAULT_AUTOPLAY_INTERVAL_MS;

    function setActive(nodeList, activeClass, index) {
      nodeList.forEach(function (el) {
        var elIdx = parseInt(el.dataset.index, 10);
        el.classList.toggle(activeClass, elIdx === index);
      });
    }

    function goTo(index) {
      currentIndex = ((index % totalCount) + totalCount) % totalCount;

      setActive(productSlides, PRODUCT_SLIDE_ACTIVE, currentIndex);
      setActive(productDetails, PRODUCT_DETAILS_ACTIVE, currentIndex);
      setActive(lifestyleSlides, LIFESTYLE_SLIDE_ACTIVE, currentIndex);

      swatches.forEach(function (swatch) {
        var idx = parseInt(swatch.dataset.index, 10);
        var isActive = idx === currentIndex;
        swatch.classList.toggle(SWATCH_ACTIVE, isActive);
        if (isActive) {
          swatch.setAttribute('aria-current', 'true');
        } else {
          swatch.removeAttribute('aria-current');
        }
      });
    }

    function startAutoplay() {
      if (!autoplayEnabled || prefersReducedMotion || totalCount <= 1) return;
      stopAutoplay();
      autoplayTimer = window.setInterval(function () {
        goTo(currentIndex + 1);
      }, autoplayIntervalMs);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        var idx = parseInt(swatch.dataset.index, 10);
        if (isNaN(idx)) return;
        goTo(idx);
        startAutoplay();
      });
    });

    if (productSlidesContainer) {
      var dragStartX = 0;
      var dragDelta = 0;
      var isDragging = false;
      var activePointerId = null;

      productSlidesContainer.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        isDragging = true;
        dragStartX = e.clientX;
        dragDelta = 0;
        activePointerId = e.pointerId;
        try { productSlidesContainer.setPointerCapture(e.pointerId); } catch (err) {}
        productSlidesContainer.classList.add(DRAGGING_CLASS);
        stopAutoplay();
      });

      productSlidesContainer.addEventListener('pointermove', function (e) {
        if (!isDragging || e.pointerId !== activePointerId) return;
        dragDelta = e.clientX - dragStartX;
      });

      function endDrag(e) {
        if (!isDragging || e.pointerId !== activePointerId) return;
        isDragging = false;
        productSlidesContainer.classList.remove(DRAGGING_CLASS);
        try {
          if (productSlidesContainer.hasPointerCapture &&
              productSlidesContainer.hasPointerCapture(e.pointerId)) {
            productSlidesContainer.releasePointerCapture(e.pointerId);
          }
        } catch (err) {}

        if (Math.abs(dragDelta) > DRAG_THRESHOLD_PX) {
          goTo(currentIndex + (dragDelta < 0 ? 1 : -1));
        }
        activePointerId = null;
        dragDelta = 0;
        startAutoplay();
      }

      productSlidesContainer.addEventListener('pointerup', endDrag);
      productSlidesContainer.addEventListener('pointercancel', endDrag);
    }

    section.addEventListener('mouseenter', stopAutoplay);
    section.addEventListener('mouseleave', startAutoplay);
    section.addEventListener('focusin', stopAutoplay);
    section.addEventListener('focusout', startAutoplay);

    function onVisibilityChange() {
      if (document.hidden) {
        stopAutoplay();
      } else {
        startAutoplay();
      }
    }
    document.addEventListener('visibilitychange', onVisibilityChange);

    section._oddItShopByShadeCleanup = function () {
      stopAutoplay();
      document.removeEventListener('visibilitychange', onVisibilityChange);
    };

    startAutoplay();
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section && typeof section._oddItShopByShadeCleanup === 'function') {
      section._oddItShopByShadeCleanup();
    }
  });
})();
